<template>
  <div id="BillingDashboard">
    <jt-dashboard :title="$gettext('DASHBOARD_RECEIPT_TITLE')">
      <div class="card col-span-3 row-span-6">
        <receivement />
      </div>
      <div class="card col-span-4 row-span-6" >
        <receipt-ton ref="receiptTon" />
      </div>
      <div class="card col-span-5 row-span-3">
        <avg-residue-vehicle-per-hour />
      </div>
      <div class="card col-span-5 row-span-3">
        <avg-time-outflow />
      </div>
      <div class="card col-span-3 row-span-5">
        <invoice-month-year />
      </div>
      <div class="card col-span-4 row-span-5">
        <invoicing />
      </div>
      <div class="card col-span-5 row-span-5">
        <residue-classification />
      </div>
      <div class="card col-span-3 row-span-5">
        <commercial />
      </div>
      <div class="card col-span-4 row-span-5">
        <public-clients />
      </div>
      <div class="card col-span-5 row-span-5">
        <industrial-top-ten />
      </div>
      <div class="card col-span-3 row-span-5" >
        <operation />
      </div>
      <div class="card col-span-9 row-span-5">
        <customers-attended />
      </div>
    </jt-dashboard>
  </div>
</template>

<script>
import JtLineChart from 'src/components/charts/JtLineChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import JtCardGaugeChart from 'src/components/dashboard/dashboard-card-components/chart-card/chart-type/JtCardGaugeChart.vue'
import JtFormCard from 'src/components/dashboard/dashboard-card-components/JtFormCard.vue'
import JtInfoCard from 'src/components/dashboard/dashboard-card-components/JtInfoCard.vue'
import JtDashboard from 'src/components/dashboard/JtDashboard.vue'
import { Component, Vue } from 'vue-property-decorator'
import ResidueClassification from './ResidueClassification.vue'
import AvgTimeOutflow from './AvgTimeOutflow.vue'
import AvgResidueVehiclePerHour from './AvgResidueVehiclePerHour.vue'
import ReceiptTon from './ReceiptTon.vue'
import Receivement from './Receivement.vue'
import Invoicing from './Invoicing.vue'
import PublicClients from './PublicClients.vue'
import IndustrialTopTen from './IndustrialTopTen.vue'
import CustomersAttended from './CustomersAttended.vue'
import InvoiceMonthYear from './InvoicingMonthYear.vue'
import Commercial from './Commercial.vue'
import Operation from './Operation.vue'

@Component({
  name: 'BillingDashboard',
  components: {
    JtDashboard,
    JtInfoCard,
    JtCardDefault,
    JtFormCard,
    JtCardGaugeChart,
    JtLineChart,
    ResidueClassification,
    AvgTimeOutflow,
    AvgResidueVehiclePerHour,
    ReceiptTon,
    Invoicing,
    Receivement,
    PublicClients,
    IndustrialTopTen,
    CustomersAttended,
    InvoiceMonthYear,
    Commercial,
    Operation
  }
})
export default class BillingDashboard extends Vue {
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#BillingDashboard {

}
</style>
